import React, { ChangeEvent, FC, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type DrawImageDialogProps = {
    onAddImage: (elementId: string, filename: string) => void;
    open: boolean;
    onClose: () => void;
};
const DrawImageDialog: FC<DrawImageDialogProps> = ({ onAddImage, open, onClose }: DrawImageDialogProps) => {
    const { t: translate } = useTranslation(['common', 'orders']);
    const [filename, setFilename] = useState('');
    const [elementId, setElementId] = useState('template-new-image-blank');

    const defaultStyle = { width: '100%', outline: '1px solid #333', cursor: 'pointer' };
    const selectedStyle = { opacity: '0.8', outline: '4px solid #105c9d' };

    const onFilenameChange = (event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setFilename(value);
    };

    const onBackgroundSelect = (templateName: string) => {
        setElementId(templateName);
    };

    const handleAddImage = () => {
        onAddImage(elementId, `${filename}.png`);
        setFilename('');
        setElementId('template-new-image-blank');
    };

    const handleClose = () => {
        onClose();
        setFilename('');
        setElementId('template-new-image-blank');
    };

    return (
        <Dialog maxWidth="lg" fullWidth open={open} onClose={onClose}>
            <DialogTitle>{translate('orders:DRAW_NEW_IMAGE')}</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item md={12}>
                        <Typography variant="h3" mb={1}>
                            {translate('orders:FILENAME')}
                        </Typography>
                        <TextField
                            fullWidth
                            value={filename}
                            onChange={onFilenameChange}
                            label={translate('orders:FILENAME')}
                        />
                    </Grid>
                    <Grid item md={12}>
                        <Typography variant="h3" mb={1}>
                            {translate('orders:SELECT_IMAGE_BACKGROUND')}
                        </Typography>
                    </Grid>
                    <Grid item md={4}>
                        <img
                            style={{
                                ...defaultStyle,
                                ...(elementId === 'template-new-image-blank' && selectedStyle),
                            }}
                            alt="img-template"
                            id="img-template-new-image-blank"
                            onClick={() => onBackgroundSelect('template-new-image-blank')}
                            src="/images/create-image-templates/blank.png"
                        />
                    </Grid>
                    <Grid item md={4}>
                        <img
                            style={{
                                ...defaultStyle,
                                ...(elementId === 'template-new-image-arch' && selectedStyle),
                            }}
                            alt="img-template"
                            id="img-template-new-image-arch"
                            onClick={() => onBackgroundSelect('template-new-image-arch')}
                            src="/images/create-image-templates/arch-jaw-both.png"
                        />
                    </Grid>
                    <Grid item md={4}>
                        <img
                            style={{
                                ...defaultStyle,
                                ...(elementId === 'template-new-image-roots' && selectedStyle),
                            }}
                            alt="img-template"
                            id="img-template-new-image-roots"
                            onClick={() => onBackgroundSelect('template-new-image-roots')}
                            src="/images/create-image-templates/jaw-roots.png"
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>{translate('common:CLOSE')}</Button>
                <Button disabled={!filename || !elementId} onClick={handleAddImage}>
                    {translate('orders:ADD_IMAGE')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DrawImageDialog;
